import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon'
import clsx from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { IconEmoji } from '@tribeplatform/react-components/common'
import { useRouter } from '@tribeplatform/react-sdk'

import { getRandomColorById } from '../../../utils/colors'
import type { StaticField } from '../../Views/types'
import { getEmoji, getMedia } from '../utils'

interface Props {
  field: StaticField
  space: Space
  highlighted: boolean
  aspectRatio: StaticField['settings']['aspectRatio']
  preview: boolean
}
export const CardBanner = ({
  field,
  space,
  highlighted,
  aspectRatio,
  preview,
}: Props) => {
  const { Link } = useRouter()
  const { default: defaultUrl } = field
  const bannerSource = field.settings?.bannerSource
  const mediaUrl = getMedia({ source: bannerSource, space })
  const emojiText = getEmoji({
    source: bannerSource,
    space,
  })
  const fieldMediaUrl = mediaUrl || (preview ? defaultUrl : '')

  if (!mediaUrl && !preview) {
    return null
  }

  if (mediaUrl || bannerSource !== 'image') {
    return (
      <Link href={space?.relativeUrl ?? ''} variant="inherit" tabIndex={-1}>
        <div
          className={clsx(
            'w-full relative',
            aspectRatio || 'aspect-video',
            highlighted && 'border-2 border-focused',
          )}
        >
          <div
            className="w-full h-full flex justify-center items-center"
            style={{ backgroundColor: getRandomColorById(space?.id ?? '') }}
          >
            <ViewGridIcon className="w-16 h-16 text-white" />
          </div>
          <div
            className="w-full h-full bg-cover bg-center absolute top-0 start-0"
            style={{ backgroundImage: `url(${fieldMediaUrl})` }}
          ></div>
        </div>
      </Link>
    )
  }

  return (
    <Link href={space?.relativeUrl ?? ''} variant="inherit" tabIndex={-1}>
      <div
        className={clsx(
          'w-full relative',
          aspectRatio || 'aspect-video',
          highlighted && 'border-2 border-focused',
        )}
      >
        <div className="w-full h-full flex justify-center items-center">
          <IconEmoji text={emojiText} size="2xl" />
        </div>
      </div>
    </Link>
  )
}
